<template>
  <!-- 用户端的喜欢和关注的 -->
  <div class="user_discovery_warp">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-tabs v-model="active" color="#F8D541" line-width="30px" sticky>
        <van-tab title="喜欢" name="like">
          <div class="search_content">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
              <Waterfall
                :minCol="2"
                :maxCol="2"
                :percent="[1,1]"
                :gutterHeight="10"
                :width="itemWidth"
                :gutterWidth="gutterWidth"
              >
                <itemContent v-for="(item,index) in list" :key="index" :item="item" :like="item.like" :likeCount="item.likeCount" isNavtie="1"/>
              </Waterfall>
            </van-list>
          </div>
        </van-tab>
        <van-tab title="关注" name="follew">
          <van-list v-model="loadingFollew" :finished="finishedFollew" finished-text="没有更多了"  @load="onLoadFollew">
            <beeItem v-for="(item,index) in bees" :key="index" :item="item" @changeList="onRefresh" bees="bees"/>
          </van-list>
        </van-tab>
      </van-tabs>
    </van-pull-refresh>
  </div>
</template>
<script>
import beeItem from "./components/beeItem";
import { Waterfall } from "vue2-waterfall";
import itemContent from "./components/itemContent";
import http from "@/utils/axios";
export default {
  data() {
    return {
      active: "like",
      list: [],
      bees: [],
      pageNum: 1,
      pageNumFollew:1,
      loading: false,
      finished: false,
      loadingFollew: false,
      finishedFollew: false,
      refreshing: false
    };
  },
  methods: {
    onLoad() {
      this.getDiscoverData();
    },
    onLoadFollew(){
      console.log(this.pageNumFollew);
      this.getBeesData();
    },
    // 获取蜜蜂
    getBeesData() {
      http({
        url: "/order/appuser/userfollow/user/userfollowlist",
        method: "post",
        parmes: {
          pageNum: this.pageNumFollew,
          pageSize: 200,
        }
      }).then(rps => {
        if (rps.code == 200) {
          if (rps.data.pages == 0) {
            this.finishedFollew = true;
          } else {
            if (rps.data.list.length === 0) {
              this.finishedFollew = true;
            } else {
              this.finishedFollew = false;
              this.pageNumFollew++;
            }
            this.bees = this.bees.concat(rps.data.list);
          }
          console.log(this.finished);
          this.loadingFollew = false;
        }
      });
    },
    //获取发现
    getDiscoverData() {
      http({
        url: "/order/appuser/beesdiscover/likediscoverlist",
        method: "post",
        parmes: {
          pageNum: this.pageNum,
          pageSize: 100
        }
      }).then(rps => {
        if (rps.code == 200) {
          if (rps.data.pages == 0) {
            this.finished = true;
          } else {
            if (rps.data.list.length === 0) {
              this.finished = true;
            } else {
              this.finished = false;
              this.pageNum++;
            }
            this.list = this.list.concat(rps.data.list);
          }
          this.loading = false;
        }
      });
    },
    changeDataFun(item) {
      this.pageNum = 1;
      this.pageNumFollew=1;
      // this.list= [];
      // this.bees=[];
      this.active = item;
      // if (item == "like") {
      //   this.getDiscoverData();
      // } else {
      //   this.getBeesData();
        
      // }
    },
    onRefresh() {
      // window.location.reload();
      console.log(this.active)
      // this.pageNum = 1;
      // this.pageNumFollew=1;
      // this.list= [];
      // this.bees=[];
      this.refreshing = false;
      if (this.active == "like") {
        this.pageNum = 1;
         this.list= [];
        this.getDiscoverData();
      } else {
        this.pageNumFollew=1;
        this.bees=[];
        this.getBeesData();
      }
    }
  },
  components: {
    beeItem,
    Waterfall,
    itemContent
  },
  computed: {
    itemWidth() {
      return 133 * 0.5 * (document.documentElement.clientWidth / 375);
    },
    gutterWidth() {
      return 10 * 0.5 * (document.documentElement.clientWidth / 375);
    }
  },
  created(){
    this.$loading.hide();
  }
};
</script>
<style lang="less" scoped>
.user_discovery_warp {
  background-color: #fff;
  .search_content {
    padding: 20px;
  }
}
</style>